// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".u-79s2qHDSoGHs {\n  color: var(--ds-text, #172b4d);\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.008em;\n  line-height: 24px;\n  margin-top: 28px;\n  display: block;\n  text-align: center;\n  margin-top: 64px;\n  margin-bottom: 16px;\n}\n.iQRUyl10f2NJFu {\n  color: var(--ds-text, #172b4d);\n  display: block;\n  text-align: center;\n  font-size: 14px;\n  line-height: 20px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerMessage": "u-79s2qHDSoGHs",
	"secondaryMessage": "iQRUyl10f2NJFu"
};
export default ___CSS_LOADER_EXPORT___;
